import React, { useEffect, useRef, useState } from "react";
import { Button, Result, Spin } from "antd";
import { useHistory } from "react-router-dom";
import { Success } from "../../../commons/Messages/Messages";
import { mailApi, getErrorMessage, oauthRedirectUri } from "./mailApi";
import { storeAccount } from "./mailStorage";
import { useMailTranslation } from "./useMailTranslation";
import "./Mail.css";

// Google/Microsoft redirect here after consent. The code is handed to the backend
// with the normal session token, which ties the new mailbox to this user and tenant.
const MailOAuthCallback = () => {
  const { t } = useMailTranslation();
  const history = useHistory();
  const [error, setError] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    // The authorization code is single-use; guard against StrictMode double effects.
    if (started.current) return;
    started.current = true;

    const params = new URLSearchParams(window.location.search);
    // Drop code/state from the address bar and browser history right away.
    window.history.replaceState(null, "", window.location.pathname);

    if (params.get("error")) {
      setError(
        params.get("error") === "access_denied"
          ? t("Sign-in was cancelled.")
          : params.get("error_description") || params.get("error")
      );
      return;
    }

    mailApi
      .completeOAuth({
        code: params.get("code"),
        state: params.get("state"),
        redirectUri: oauthRedirectUri()
      })
      .then(res => {
        storeAccount(res.data._id);
        Success(t(res.successMessage));
        history.replace("/user/mail");
      })
      .catch(err => setError(getErrorMessage(err, t("Failed to connect mailbox"))));
  }, []);

  if (error) {
    return (
      <Result
        status="warning"
        title={t("The mailbox could not be connected")}
        subTitle={t(error)}
        extra={
          <Button type="primary" onClick={() => history.replace("/user/mail")}>
            {t("Back to mail")}
          </Button>
        }
      />
    );
  }

  return (
    <div className="mail-center">
      <Spin size="large" tip={t("Connecting your mailbox…")}>
        <div style={{ width: 200, height: 80 }} />
      </Spin>
    </div>
  );
};

export default MailOAuthCallback;
